import { render, staticRenderFns } from "./ColorDropdown.vue?vue&type=template&id=4edcd140&scoped=true"
import script from "./ColorDropdown.vue?vue&type=script&lang=ts"
export * from "./ColorDropdown.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ColorDropdown.vue?vue&type=style&index=0&id=4edcd140&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4edcd140",
  null
  ,true
)

export default component.exports